import React from "react"
import { useSelector } from "react-redux"

import { ACTIVE, INACTIVE } from "const"
import { StoreType, ModuleFilters } from "client/store"
import { ActiveInactive } from "client/utils"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchModule {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: ModuleFilters
    onFilter: (filters: ModuleFilters) => void
}

const statusArray = [ACTIVE, INACTIVE]

const ModuleSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchModule) => {
    const lang = useSelector((state: StoreType) => state.system.lang)

    const popupFilters: SearchFilter[] = []

    statusArray.forEach((status: ActiveInactive) => {
        popupFilters.push({
            title: lang[status],
            isActive: filters.status === status,
            onAdd: (obj: ModuleFilters) => ({
                ...obj,
                status,
            }),
            onClose: (obj: ModuleFilters) => ({
                ...obj,
                status: null,
            }),
        })
    })

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default ModuleSearch
